export const PrivacyPolicyLink = ({ label }: { label: string }) => {
  return (
    <a href="/terms-of-use.pdf" target="_blank">
      {label}
    </a>
  );
};
